var moment = require("moment-timezone");

const statistics = function(trades) {
    var stats = {
        successRate: 0,
        weekDays: [0, 0, 0, 0, 0, 0, 0],
        entryHours: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        exitHours: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        lastSeven: [],
        equity: [0],
    }

    var profits = [];
    var losts = [];


    trades.forEach(trade => {

        var openTime = moment(trade.openTimestamp)
        var closeTime = moment(trade.CloseDateTime * 1000)
        var openHour = openTime.hour()
        var closeHour = closeTime.hour()

        stats.entryHours[openHour] += trade.ClosedProfitLoss
        stats.exitHours[closeHour] += trade.ClosedProfitLoss

        stats.equity.push(stats.equity[stats.equity.length - 1] + trade.ClosedProfitLoss)

        if (trade.ClosedProfitLoss > 0) {
            profits.push(trade.ClosedProfitLoss);
        } else {
            losts.push(trade.ClosedProfitLoss);
        }
        stats.weekDays[new Date(trade.createdAt).getDay()] += 1;





        var dayStart = moment(new Date(trade.createdAt)).format('YYYY-MM-DD');

        var dayIndex = 0
        var dayExists = false

        stats.lastSeven.forEach((actualDay, index) => {
            if (actualDay.date == dayStart) {
                dayIndex = index
                dayExists = true
            }
        })

        if (dayExists) {
            stats.lastSeven[dayIndex].pl += trade.ClosedProfitLoss
        } else {
            stats.lastSeven.unshift({ createdAt: trade.createdAt, pl: trade.ClosedProfitLoss, date: dayStart })
        }






    })

    stats.lastSeven = stats.lastSeven.reverse()
    stats.lastSeven = stats.lastSeven.slice(-7)

    if (trades.length > 0) {
        stats.successRate =
            parseFloat(profits.length / (losts.length + profits.length) * 100);
    }


    trades.reverse()




    return stats
        /*
        this.user._diary.forEach((day) => {
            var dailyPL = 0;
            day._trades.forEach((trade) => {
                dailyPL += trade.ClosedProfitLoss
            })
            this.stats.lastSeven.unshift({ createdAt: day.date, pl: dailyPL, date: day.dateString });
        })
        */
};


export default statistics